import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

import styles from './AlertModal.module.scss';

import Modal from '../../Modal/Modal';
import { Button } from '../../Buttons';

class AlertModal extends Component {
  constructor(props) {
    super(props);
    this.performAction = this.performAction.bind(this);
    this.intl = props.intl;
  }

  performAction() {
    if (this.props.action) this.props.action();

    if (this.props.hide) this.props.hide();
  }

  render() {
    if (!this.props.header || (!this.props.text && !this.props.children && !this.props.content))
      return null;

    return (
      <Modal
        header={this.props.header}
        headerData={this.props.headerData}
        onDismiss={this.props.hide}
        show={this.props.show}
      >
        {this.props.text ? <p>{this.props.text}</p> : null}
        {this.props.children ? this.props.children : null}
        {this.props.content ? this.props.content : null}
        <div className={styles.buttonWrapper}>
          <Button
            primary
            value={this.intl.formatMessage({ id: 'general.ok', defaultMessage: 'Ok' })}
            onClick={this.performAction}
            className={styles.button}
          />
        </div>
      </Modal>
    );
  }
}

export default injectIntl(AlertModal);
